export const SMART_PREFILL_CONFIG = {
    apiBaseUrl: "https://generativelanguage.googleapis.com",
    apiVersions: ["v1beta", "v1"],
    models: [
        "gemini-1.5-flash",
        "gemini-1.5-flash-latest",
        "gemini-1.5-flash-001",
        "gemini-1.5-pro",
        "gemini-1.5-pro-latest",
        "gemini-1.0-pro",
        "gemini-1.0-pro-001",
        "gemini-pro",
        "gemini-pro-vision"
    ],
    methodPriority: ["generateContent", "generateText", "generateMessage"],
    maxPromptLength: 1200,
    promptRows: 5,
    maxModelNamesToShow: 6,
    maxQuestions: 50,
    minChoicesPerQuestion: 2,
    maxChoicesPerQuestion: 6,
    minGuestLimit: 1,
    maxGuestLimit: 1000,
    temperature: 0.4,
    defaultVariantColor: "#9C27B0",
    defaultMinGuests: 5,
    defaultMaxGuests: 300,
    defaultDefaultGuests: 50,
    defaultSortOrder: 0,
    defaultCategoryId: 1,
    requestRole: "user",
    apiKeyStorageKey: "admin_gemini_api_key",
    modelCacheTtlMs: 10 * 60 * 1000,
    preferredModelSubstring: "gemini"
};

export const DEFAULT_GEMINI_API_KEY = "AIzaSyBWiFY-ALIQQXZpDBg2pTvcPIz81sxxXek";

export const HEX_COLOR_REGEX = /^#[0-9a-fA-F]{6}$/;

export const MODAL_BACKDROP_STYLE = {
    backgroundColor: "rgba(0,0,0,0.5)"
};

export const DEFAULT_EVENT_TYPE_FORM = {
    display_name: "",
    emoji: "",
    variant_color: SMART_PREFILL_CONFIG.defaultVariantColor,
    min_estimated_guests: SMART_PREFILL_CONFIG.defaultMinGuests,
    max_estimated_guests: SMART_PREFILL_CONFIG.defaultMaxGuests,
    default_estimated_guests: SMART_PREFILL_CONFIG.defaultDefaultGuests,
    show_participant_names: true,
    swappable_participant_names: false,
    sort_order: SMART_PREFILL_CONFIG.defaultSortOrder,
    is_active: false,
    variant_strings: {},
    event_date: ""
};

export const SMART_PREFILL_ERROR_CODES = {
    missingApiKey: "missing_api_key",
    emptyPrompt: "empty_prompt",
    invalidResponse: "invalid_response",
    generationFailed: "generation_failed",
    modelNotFound: "model_not_found",
    modelListFailed: "model_list_failed"
};

export const WEB_IMAGE_CONFIG = {
    apiBaseUrl: "https://api.openverse.org/v1/images",
    pageSize: 10,
    imageType: "photo",
    license: "cc0,pdm",
    allowedMimeTypes: ["image/jpeg", "image/png"],
    maxResultsToTry: 5,
    fileBaseName: "dynamic-event-placeholder",
    searchFallbackSuffix: "event"
};

export const buildSmartPrefillPrompt = (prompt) => `You are creating a custom Five On event type for a betting app admin panel.
Generate an event type and recommended questions based on this description:
"${prompt}"

Return ONLY valid JSON with this exact shape:
{
  "eventType": {
    "display_name": "string",
    "emoji": "string",
    "variant_color": "#RRGGBB",
    "min_estimated_guests": 5,
    "max_estimated_guests": 300,
    "default_estimated_guests": 50,
    "show_participant_names": true,
    "swappable_participant_names": false,
    "sort_order": 0,
    "variant_strings": {}
  },
  "questions": [
    { "question": "string", "choices": ["string", "string"], "sort_order": 0 }
  ]
}

Rules:
- Use at most ${SMART_PREFILL_CONFIG.maxQuestions} questions.
- Each question must have between ${SMART_PREFILL_CONFIG.minChoicesPerQuestion} and ${SMART_PREFILL_CONFIG.maxChoicesPerQuestion} choices.
- Keep questions short, specific, and event-related.
- Use a valid hex color for variant_color.
- Use integers for guest counts and sort_order.
- If unsure, use sensible defaults.
- No markdown, no extra text.`;
